export const EVENTS = {
  CHANGE_AUTH_STATUS: "changeAuthStatus",
  CHANGE_IP_COUNTRY: "changeIpCountry",
  CHANGE_COUNTRY: "changeCountry",
  CHANGE_LANGUAGE: "changeLanguage",
  CHANGE_CURRENCY: "changeCurrency",
  CHANGE_SETTING: "changeSetting",
  UPDATE_PRICE_TAGS: "updatePriceTags",
  UPDATE_PRICE_SAVINGS: "updatePriceSavings",
  MINI_APP_CHANGE_LANGUAGE: "MiniAppChangeLanguage",
  MINI_APP_CHANGE_SHIPPING_COUNTRY: "MiniAppChangeShippingCountry",
  MINI_APP_CHANGE_BILLING_COUNTRY: "MiniAppChangeBillingCountry",
  MINI_APP_CHANGE_CURRENCY: "MiniAppChangeCurrency",
  RESIZE_SCREEN_MOBILE: "resizeMobile",
  SWITH_THEME: "switchTheme",
};

export function listenEvent(jobId, cb = () => { }) {
  try {
    // if (document.events && document.events[jobId]) {
    //   return;
    // }
    if (!document.events) document.events = {};
    let callback = function (e) {
      typeof (cb) === "function" && cb(e.detail);
    }
    document.events[jobId] = callback;
    document.addEventListener(jobId, callback);
  } catch (error) {

  }
};

export function callEvent(jobId, details) {
  try {
    document.dispatchEvent(new CustomEvent(jobId, { "detail": details }));
  } catch (error) {

  }
};

export function removeEvent(jobId) {
  try {
    let events = document.events;
    if (events && typeof events === "object" && Object.keys(events).length) {
      Object.keys(events).forEach(key => {
        if (jobId === key) {
          document.removeEventListener(jobId, events[key]);
        }
      });
    }
  } catch (error) {
  }
};